import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

var Surface = function Surface(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false"
  }, props));
};

export default Surface;
//# sourceMappingURL=index.js.map